<template>
  <div>
    <div class="vx-card p-6">
      <div style="margin-top:10px;margin-bottom:20px;font-size: 40px;text-align: center;">BORÇ ALACAK BAZLI MUHASEBE HAREKETLERİ İZLEME</div>

      <div v-if="Object.keys($route.params).length > 0">
        
        <label style="color:orange; font-size: 30px;">{{ "Açıklama : " + hrManagementList[0].accountDescription }}</label>
      </div>
      <vs-divider />

      <div v-if="Object.keys($route.params).length == 0 || 1 == 1">
           <!---*************************************************************************-->
           <form class="vx-row"  @submit.prevent="getMovementList()">
            <div style="width: 100%;">
                <!--1. Row-->
            <div class="vx-row ml-3">
            <div class="vx-col md:w-1/6">
              <label class="text-sm"><b>İşlem Id</b></label>
              <vs-input  class="w-full" type="number" v-model="searchModel.moduleId" /> 
            </div>
            <div class="vx-col md:w-1/6">
              <label class="text-sm"><b>Müşteri Id</b></label>
              <vs-input  class="w-full" type="number" v-model="searchModel.customerId" /> 
            </div>
            <div class="vx-col md:w-1/6">
              <label class="text-sm"><b>İşlem Türü</b></label>
              <v-select class="w-full" placeholder="Aksiyon Tür" label="name" :options="transactionTypeList" v-model="searchModel.transactionType" :reduce="(row) => row.value">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select> 
            </div>
               <div class="vx-col md:w-1/6">
              <label class="text-sm"><b>Hesap No</b></label>
              <vs-input  class="w-full" type="number" v-model="searchModel.accountId" />
            </div>
             <div class="vx-col md:w-1/6" v-if="1==2">
              <label class="text-sm"><b>Durum</b></label>
              <v-select class="w-full" placeholder="Durum" label="name" :options="statusList" v-model="searchModel.status" :reduce="(row) => row.value">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select> 
            </div>
                <div class="vx-col md:w-1/6" >
              <label class="text-sm"><b>Hesap Tür</b></label>
              <v-select class="w-full" placeholder="Hesap Tür" label="name" :options="accountTypeList" v-model="searchModel.accountType" :reduce="(row) => row.value">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
            </div>
            <div class="vx-col md:w-1/6" >
              <label class="text-sm"><b>Satış Yapan</b></label>
              <v-select class="w-full" placeholder="Satış Yapan" label="userName" :options="personnalList" v-model="searchModel.createdUserId" :reduce="(row) => row.userId">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
            </div>
             </div>
            <!--2.row-->
            <div class="vx-row ml-3 mt-3">
             <div class="vx-col md:w-1/6" >
              <label class="text-sm"><b>Borç/Alacak</b></label>
              <v-select class="w-full" placeholder="Borç/Alacak" label="name" :options="debitCreditList" v-model="searchModel.debitCredit" :reduce="(row) => row.value">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
            </div>
            <div class="vx-col md:w-1/6" >
              <label class="text-sm"><b>Başlangıç</b></label>
               <vs-input  class="w-full" type="date" v-model="searchModel.startDate" />
            </div>
             <div class="vx-col md:w-1/6" >
              <label class="text-sm"><b>Bitiş</b></label>
               <vs-input  class="w-full" type="date" v-model="searchModel.finishDate" />
            </div>
            <div class="vx-col md:w-1/6" >
              <label class="text-sm"><b>Muh. Baş.</b></label>
              <vs-input  class="w-full" type="date" v-model="searchModel.startTransactionDate" />
            </div>
             <div class="vx-col md:w-1/6" >
              <label class="text-sm"><b>Muh. Bit.</b></label>
              <vs-input  class="w-full" type="date" v-model="searchModel.finishTransactionDate" />
            </div>
            <div class="vx-col md:w-1/6" >
            <div class="vx-row">
            <div class="vx-col md:w-1/2">
            <vs-button style="margin-top:15px;">Ara</vs-button>
            </div>
            <div class="vx-col md:w-1/2">
              
              <div style="cursor: pointer; width: 100px; margin-top:20px ;color: rgba(0, 143, 251, 0.85); font-weight: bold; font-size: 1.2rem;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="hrManagementList" class>İndir</JsonExcel>
              </div>
            </div>
            </div>

            </div>

            </div>
           
            </div>
           </form>

           <!--***************************************************************************--->
        
         
          
           <!-- <div style="cursor: pointer; width: 100px; " class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="hrManagementList" class>İndir</JsonExcel>
          </div> -->


        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
      </div>

      <vs-divider />
      <!-- prompt for addnew personnel -->

      <!-- AgGrid Table -->

      <ag-grid-vue
        ref="agGridTable"
        :gridOptions="gridOptions"
        style="height: 60vh;"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="hrManagementList"
        rowSelection="single"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :rowClassRules="rowClassRules"
        :context="context"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { repository } from "@/_services/repository.js";
import CellRendererDetailList from "./CellRenderer/CellRendererDetailList.vue";
import vSelect from "vue-select";
import CellRendererActions from "./CellRenderer/CellRendererActions.vue";
import JsonExcel from "vue-json-excel";

export default {
  components: {
    vSelect,
    CellRendererDetailList,
    CellRendererActions,
    AgGridVue,
    JsonExcel
  },
  data() {
    return {
      personnalList: [],
      context: null,
      hrManagementList: [{ accountDescription: null }],
      transactionTypeList: [
        { name: "Satış", value: "Sale" },
        { name: "Harcama", value: "Expense" },
        { name: "Gelir", value: "Income" },
      ],

      searchModel: { transactionType: null, finishDate: null, moduleId: null, statusId: null, createUserId: null, customerId: null, status: null, 
      startTransactionDate: null, finishTransactionDate: null, accountType: null, teamId:this.$store.state.userData.teamId,  },
      statusList: [
        { name: "Bekleyen", value: "B" },
        { name: "Muhabeleşmiş", value: "M" },
      ],

      debitCreditList: [
        { name: "Borç", value: "B" },
        { name: "Alacak", value: "A" },
      ],

      accountTypeList: [
        { name: "Müşteri", value: "Customer" },
        { name: "Şirket", value: "Company" },
      ],

      delayedSearchTimer: "",
      gridApi: null,
      rowClassRules: null,

      gridOptions: { rowHeight: 75, suppressRowTransform: true },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      /* eslint-disable */
      columnDefs: [
        {
          headerName: "Fiş Id",
          field: "accountMovementAndDetailId",
          filter: true,
          width: 25,
        },

        {
          headerName: "Hesap No",
          field: "accountId",
          filter: true,
          width: 25,
        },

        {
          headerName: "Hesap Tür",
          field: "accountTypeDescription",
          filter: true,
          width: 25,
        },

        {
          headerName: "Tür",
          field: "movementType",
          filter: true,
          width: 50,
        },
        {
          headerName: "Borç/Alacak",
          field: "debitCredit",
          filter: true,
          width: 25,
        },
        {
          headerName: "Tutar",
          field: "amountStr",
          filter: true,
          width: 350,
        },
        {
          headerName: "Giriş Tarihi",
          field: "date",
          filter: true,
          width: 25,
        },
        {
          headerName: "Giriş Personel",
          field: "createdUserName",
          filter: true,
          width: 25,
        },

        {
          headerName: "Muhasebe Tarihi",
          field: "transactionDate",
          filter: true,
          width: 25,
        },
        {
          headerName: "Muhasebe Personel",
          field: "transactionUserName",
          filter: true,
          width: 25,
        },
        {
          headerName: "Muhasebe Bilgileri",
          cellRendererFramework: "CellRendererDetailList",
          filter: false,
          width: 50,
        },
        {
          headerName: "Detay",
          field: "transactions",
          width: 50,
          cellRendererFramework: "CellRendererActions",
        },
      ],
    };
  },

  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 8;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  created: async function() {
    if (this.$route.params != null && this.$route.name == "AccountCompanyMovementWatch" && this.$route.params.accountId > 0) {
      this.searchModel.accountId = this.$route.params.accountId;
      this.searchModel.accountType = "Company";
      this.searchModel.status = "M";
    } else if (this.$route.params != null && this.$route.name == "AccountMovementWatchByAccountId" && this.$route.params.accountId > 0) {
      this.searchModel.accountId = this.$route.params.accountId;
      this.searchModel.accountType = "Customer";
      this.searchModel.statusId = "M";
    } else if (this.$route.params != null && this.$route.name == "AccountMovementWatchByCustomerId" && this.$route.params.customerId > 0) {
      this.searchModel.customerId = this.$route.params.customerId;
      this.searchModel.accountType = "Customer";
    } else if (this.$route.params != null && this.$route.name == "AccountCompanyConsolidatedMovementWatch" && this.$route.params.accountCompanyTypeId > 0) {
      this.searchModel.accountCompanyTypeId = this.$route.params.accountCompanyTypeId;
      this.searchModel.currencyId = this.$route.params.currencyId;
      this.searchModel.accountType = "Company";
      this.searchModel.statusId = "M";
    } else if (this.$route.params != null && this.$route.name == "ConsolidatedPersonnelWatch" && this.$route.params.userId > 0) {
      this.searchModel.userId = this.$route.params.userId;
      this.searchModel.groupName = this.$route.params.groupName;
      this.searchModel.accountType = "Company";
      this.searchModel.statusId = "M";
    } else if (this.$route.params != null && this.$route.name == "AccountMovementConsolidatedRegionWatch" && this.$route.params.regionId > 0) {
      this.searchModel.regionId = this.$route.params.regionId;
      this.searchModel.startTransactionDate = this.$route.params.startDate;
      this.searchModel.finishTransactionDate = this.$route.params.finishDate;
      this.searchModel.currencyId = this.$route.params.currencyId;
      this.searchModel.accountType = "Company";
      this.searchModel.statusId = "M";
    } else if (this.$route.params != null && this.$route.name == "AccountMovementConsolidatedPersonnelWatch" && this.$route.params.userId > 0) {
      this.searchModel.userId = this.$route.params.userId;
      this.searchModel.startTransactionDate = this.$route.params.startDate;
      this.searchModel.finishTransactionDate = this.$route.params.finishDate;
      this.searchModel.currencyId = this.$route.params.currencyId;
      this.searchModel.displayType = "DetailPersonnelSale";
    } else if (this.$route.params != null && this.$route.name == "AccountMovementSaleForRegionDashboardConsolidatedTL" && this.$route.params.regionId >= 0) {
      this.searchModel.regionId = this.$route.params.regionId;
      this.searchModel.startTransactionDate = this.$route.params.startDate;
      this.searchModel.finishTransactionDate = this.$route.params.finishDate;
      this.searchModel.currencyId = this.$route.params.currencyId;
      this.searchModel.displayType = "DetailRegionSale";
    } else if (this.$route.params != null && this.$route.name == "AccountMovementSaleForBrandStatisticalDashboardConsolidatedTL" && this.$route.params.brand != null) {
      this.searchModel.searchType='Sale';
      this.searchModel.brand = this.$route.params.brand;
      this.searchModel.startTransactionDate = this.$route.params.startDate;
      this.searchModel.finishTransactionDate = this.$route.params.finishDate;
      this.searchModel.currencyId = this.$route.params.currencyId;
      this.searchModel.displayType = "DetailBrandSale";
    } else if (this.$route.params != null && this.$route.name == "AccountMovementForExpenseStatisticalDashboardConsolidatedTL" && this.$route.params.accountCompanyTypeId > 0) {
      this.searchModel.accountCompanyTypeId = this.$route.params.accountCompanyTypeId;
      this.searchModel.startTransactionDate = this.$route.params.startDate;
      this.searchModel.finishTransactionDate = this.$route.params.finishDate;
      this.searchModel.currencyId = this.$route.params.currencyId;
      this.searchModel.displayType = "DetailExpense";
    } else if (this.$route.params != null && this.$route.name == "AccountMovementForCustomerPaymentStatisticalDashboardConsolidatedTL" && this.$route.params.userId > 0) {
      this.searchModel.userId = this.$route.params.userId;
      this.searchModel.startTransactionDate = this.$route.params.startDate;
      this.searchModel.finishTransactionDate = this.$route.params.finishDate;
      this.searchModel.currencyId = this.$route.params.currencyId;
      this.searchModel.displayType = "DetailCustomerPayment";
      this.searchModel.searchType = "CustomerPayment";
    } else if (this.$route.params != null && this.$route.name == "AccountCompanyConsolidatedCashRegionWatch" && this.$route.params.accountCompanyCashRegionId > 0) {
      this.searchModel.accountCompanyCashRegionId = this.$route.params.accountCompanyCashRegionId;
      this.searchModel.currencyId = this.$route.params.currencyId;
      this.searchModel.accountType = "Company";
      this.searchModel.statusId = "M";
    }

    console.log(this.searchModel);
    Promise.all([this.getUsers(), this.getMovementList()]);
  },
  methods: {
    getUsers: async function() {
      await repository.getAll("User/getUserList").then((r) => {
        this.personnalList = r.list;
      });

      return this.personnalList;
    },

    getMovementList: async function() {
      this.$vs.loading();
      this.hrManagementList = [{ accountDescription: null }];
      if (this.$route.name == "AccountCompanyConsolidatedMovementWatch" || this.$route.name == "ConsolidatedPersonnelWatch") {
        this.hrManagementList = await repository.postEntity("Accounting/GetConsolidatedAccountCompanyCashFlow", this.searchModel).then((r) => r.list);
      } else if (this.$route.name == "AccountMovementConsolidatedRegionWatch") {
        this.hrManagementList = await repository.postEntity("Accounting/GetAccountMovementConsolidatedRegionWatch", this.searchModel).then((r) => r.list);
      } else if (
        this.$route.name == "AccountMovementConsolidatedPersonnelWatch" ||
        this.$route.name == "AccountMovementSaleForRegionDashboardConsolidatedTL" ||
        this.$route.name == "AccountMovementSaleForBrandStatisticalDashboardConsolidatedTL" ||
        this.$route.name == "AccountMovementForCustomerPaymentStatisticalDashboardConsolidatedTL" ||
        this.$route.name == "AccountMovementForExpenseStatisticalDashboardConsolidatedTL"
      ) {
        this.hrManagementList = await repository.postEntity("Accounting/GetStatisticalDashboardData", this.searchModel).then((r) => r.list);
      } else if (this.$route.name == "AccountCompanyConsolidatedCashRegionWatch") {
        this.hrManagementList = await repository.postEntity("Accounting/GetAccountCompanyConsolidatedCashRegionWatch", this.searchModel).then((r) => r.list);
      } else {
        this.hrManagementList = await repository.postEntity("Accounting/GetAccountMovementCashFlowWatch", this.searchModel).then((r) => r.list);
      }
      this.$vs.loading.close();
    },
  },
  beforeMount() {
    this.rowClassRules = {};
    this.context = { componentParent: this };
  },
  beforeUpdate() {
    this.gridApi.sizeColumnsToFit();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    this.gridApi.sizeColumnsToFit();
  },
};
</script>

<style lang="scss" scoped></style>
